// @flow
import cn from 'classnames';
import {HelmetTitle} from 'modules/common/components/HelmetTitle';
import chrome from 'modules/common/images/chrome-logo.png';
import edge from 'modules/common/images/edge-logo.png';
import fx from 'modules/common/images/fx-logo.png';
import safari from 'modules/common/images/safari-logo.png';
import React from 'react';
import styles from './styles.local.less';

/**
 * Если зашли на сайт в IE
 * @return {*} компонент плашки по центру экрана
 */
export function OutdatedBrowser() {
    return (
        <>
            <HelmetTitle>
                <title>Your browser is not supported</title>
            </HelmetTitle>
            <div className={styles.outdatedBrowserWrapper}>
                <div className={styles.outdatedBrowserPanel}>
                    <h1 className="m-b_m t-a_c">Your browser is not supported</h1>
                    <p className={cn('t-a_c', styles.outdatedBrowserSubheading)}>
                        For correct work of the site try one of the browsers offered or update your browser.
                    </p>
                    <div className={styles.outdatedBrowserBoard}>
                        <a
                            className={styles.outdatedBrowserBoardItem}
                            href="https://www.microsoft.com/ru-ru/edge?form=MA13DE&OCID=MA13DE"
                            rel="noreferrer"
                            target="_blank"
                        >
                            <img alt="edge-logo" className={styles.outdatedBrowserEdgeLogo} src={edge} />
                            <div className={cn('f_l ', styles.outdatedBrowserLink)}>Microsoft Edge</div>
                        </a>
                        <a className={styles.outdatedBrowserBoardItem} href="https://www.apple.com/ru/safari/" rel="noreferrer" target="_blank">
                            <img alt="safari-logo" className={styles.outdatedBrowserSafariLogo} src={safari} />
                            <div className={cn('f_l ', styles.outdatedBrowserLink)}>Safari</div>
                        </a>
                        <a
                            className={styles.outdatedBrowserBoardItem}
                            href="https://www.google.com/intl/ru_ru/chrome/"
                            rel="noreferrer"
                            target="_blank"
                        >
                            <img alt="chrome-logo" className={styles.outdatedBrowserChromeLogo} src={chrome} />
                            <div className={cn('f_l ', styles.outdatedBrowserLink)}>Google Chrome</div>
                        </a>
                        <a
                            className={styles.outdatedBrowserBoardItem}
                            href="https://www.mozilla.org/ru/firefox/download/thanks/"
                            rel="noreferrer"
                            target="_blank"
                        >
                            <img alt="fx-logo" className={styles.outdatedBrowserEdgeLogo} src={fx} />
                            <div className={cn('f_l ', styles.outdatedBrowserLink)}>Mozilla Firefox</div>
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
}
